export default "__VITE_ASSET__d0cc0f2c__"